<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-06 16:56:04
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-10 11:24:51
-->
<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="drawRow.type === 'add' ? $t('system::team::添加员工') : $t('system::team::编辑员工')"
    @close="onChange"
    :visible.sync="dialogVisible"
    destroy-on-close
    width="500px"
  >
    <el-form
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="100px"
      ref="staffForm"
    >
      <el-form-item prop="keyword" :label="$t('system::team::account')">
        <el-input
          class="input-item"
          v-model="form.keyword"
          :disabled="drawRow.type === 'edit'"
          :placeholder="$t('system::team::placeholdere_info')"
        ></el-input>
      </el-form-item>
      <el-form-item prop="teamId" :label="$t('system::team::team')">
        <el-cascader
          class="input-item"
          :placeholder="$t('system::team::placeholdere_team')"
          :options="teamDataList"
          v-model="form.teamId"
          :props="{ checkStrictly: false, value: 'id', label: 'name', children: 'children' }"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="roleId" :label="$t('system::team::role')">
        <el-select
          :remote-method="remoteMethod"
          filterable
          multiple
          remote
          v-if="defaultRoleList.length"
          class="input-item"
          v-model="form.roleId"
          :loading="vloading"
          placeholder="请选择"
        >
          <el-option
            :placeholder="$t('system::team::placeholdere_role')"
            v-for="item in roleList"
            :key="item.roleId"
            :label="item.roleName"
            :value="item.roleId"
          ></el-option>
        </el-select>
        <span v-else>
          {{ $t('system::team::placeholdere_role_to') }}
          <a @click="toLink">{{ $t('system::team::placeholdere_role_to_link') }}</a>
        </span>
      </el-form-item>
    </el-form>
    <div class="footer_class" slot="footer" style="text-align: center; display: block">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button @click="sumbit" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getRoleList } from '@/server/system'
import { teamStaffAdd, teamStaffEdit } from '@/server/team-manage'
export default {
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    teamData: {
      default: () => [],
    },
    drawRow: {
      default: () => {},
    },
  },
  computed: {
    teamDataList() {
      const fn = arr => {
        return arr.map(item => {
          if (item.children && item.children.length) {
            fn(item.children)
          } else if (item.children) {
            delete item.children
          }
          return item
        })
      }

      return fn(this.$deepClone(this.teamData))
    },
  },
  watch: {
    visible(bool) {
      this.dialogVisible = bool
      if (bool) {
        this.getRoleList(() => {
          this.defaultRoleList = this.$deepClone(this.roleList)
        })
      }
    },
    drawRow: {
      handler: function (data) {
        if (this.$refs.staffForm) {
          this.$refs.staffForm.resetFields()
        }
        this.form = {
          ...data.data,
        }
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      vloading: false,
      roleList: [],
      defaultRoleList: [],
      form: {},
      options: [],
      rules: {
        keyword: [{ required: true, message: this.$t('system::team::placeholdere_info'), trigger: 'blur' }],
        roleId: [
          { required: true, type: 'array', message: this.$t('system::team::placeholdere_role'), trigger: 'blur' },
        ],
        teamId: [{ required: true, message: this.$t('system::team::placeholdere_team'), trigger: 'blur' }],
      },
      loading: false,
    }
  },
  mounted() {},
  methods: {
    toLink() {
      this.dialogVisible = false
      this.$router.push({
        path: '/rbac',
      })
    },
    async remoteMethod(query) {
      this.vloading = true
      const data = await getRoleList({
        pageNum: 1,
        pageSize: 100,
        roleName: query,
      })
      this.vloading = false
      if (data.data.code === this.$code) {
        this.roleList = data.data.data.items
      }
    },

    async getRoleList(fn) {
      this.loading = true
      const data = await getRoleList({
        pageNum: 1,
        pageSize: 100,
        roleName: this.searchRole,
      })
      this.loading = false
      if (data.data.code === this.$code) {
        this.roleList = data.data.data.items
        if (fn) fn()
      }
    },

    async save() {
      const params = { ...this.$deepClone(this.form) }
      params.teamId = Array.isArray(params.teamId) ? params.teamId.pop() : params.teamId
      const data = await teamStaffAdd(params)
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::add_success'))
        this.onChange()
        this.$emit('refresh')
      }
    },
    async edit() {
      const params = { ...this.$deepClone(this.form) }
      params.teamId = Array.isArray(params.teamId) ? params.teamId.pop() : params.teamId
      const data = await teamStaffEdit(params)
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
        this.onChange()
        this.$emit('refresh')
      }
    },
    sumbit() {
      this.$refs.staffForm.validate(valid => {
        if (valid) {
          this.drawRow.type === 'add' ? this.save() : this.edit()
        }
      })
    },
    handleSelect(val) {
      console.log(val)
    },
    onChange() {
      this.$emit('change', false)
    },
  },
}
</script>
<style scoped lang="scss">
.input-item {
  width: 100%;
}
</style>
